import React, { useEffect, useState } from 'react'
import { Button, Grid, Paper, TextField, Tooltip } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit';
import { globalGetService, globalPutService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { useSnackbar } from 'notistack';
import { regexConstants } from '../../../constants/regEx';
import { PageLoader } from '../../../shared_elements';

export default function Config() {
  const [restData, setRestData] = useState({})
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({});
  const [type, setType] = useState('view');
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    getConfigData()
  }, [])
  const getConfigData = () => {
    setLoading(true)
    globalGetService(`new-mr-calculator/lessor-rest-period/`)
    .then(response => {
        setLoading(false)
        if (checkApiStatus(response)) {
          setRestData(response.data.data)
        }
      })
  }
  const onFieldChange = (e, key, value) => {
    if ((value && regexConstants.onlyNumeric.test(value)) || (value == '')) {
      setRestData({
        ...restData,
        [key]: value
      })
    } else {
      e.preventDefault()
    }
  }
  const editConigData = (data) => {
    let validationInputs = {}
    validationInputs={
      ...validationInputs,
      airframe_rest_days:restData?.airframe_rest_days || restData?.airframe_rest_days ===0?'':'Please enter Airframe REST Period',
      apu_rest_days:restData?.apu_rest_days|| restData?.apu_rest_days ===0 ?'':'Please enter APU REST Period',
      engine_rest_days:restData?.engine_rest_days|| restData?.engine_rest_days ===0  ?'':'Please enter Engine REST Period',
      landing_gear_rest_days:restData?.landing_gear_rest_days|| restData?.landing_gear_rest_days ===0 ?'':'Please enter LG REST Period'
    }
    if(Object.keys(validationInputs).every((k)=>{return (validationInputs[k] ==='' )})){
    setError({})
    let payload = Object.assign(restData)
    setLoading(true)
    globalPutService(`new-mr-calculator/lessor-rest-period/`, payload)
      .then(response => {
        setLoading(false)
        if (checkApiStatus(response)) {
          setType('view')
          enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        } else{
          // getConfigData()
          enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        }
      })
    } else { 
      setError(validationInputs)
    }
  }
  return (
    <Paper className='config-container' style={{ minHeight: `${window.innerHeight - 62}px` }}>
      {loading ? <PageLoader/>: null}
      <Grid container spacing={2} style={{ padding: '20px' }}>
        <Grid item xs={12}>
          <h2>REST Period</h2>
          <div style={{ float: "right" }}>
            {type == 'view' ?
            <Tooltip title='Edit REST Period' placement='top' arrow>
              <EditIcon onClick={() => setType('edit')} color='primary' fontSize='small' style={{ cursor: 'pointer' }} />
            </Tooltip>
              : <div> &nbsp;</div>}
          </div>
        </Grid>
        <Grid item xs={6}>
          <TextField
            required
            name='Airframe REST Period'
            label='Airframe REST Period'
            fullWidth
            value={restData.airframe_rest_days || restData.airframe_rest_days== 0? restData.airframe_rest_days:''}
            disabled={type === 'view'}
            variant='outlined'
            onChange={(e) => { onFieldChange(e, 'airframe_rest_days', e.target.value) }}
            placeholder='Enter Airframe REST Period'
            InputLabelProps={{ shrink: true }}
            InputProps={{ endAdornment: <span style={{ marginLeft: '10px' }}>Day(s)</span>}}
            error={error?.airframe_rest_days ||false}
            onFocus={()=>setError({...error,airframe_rest_days:''})}
            helperText={error?.airframe_rest_days ||''}
            style={{ marginBottom: '20px' }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            required
            name='Engine REST Period'
            label='Engine REST Period'
            fullWidth
            value={restData.engine_rest_days || restData.engine_rest_days== 0? restData.engine_rest_days:''}
            disabled={type === 'view'}
            variant='outlined'
            onChange={(e) => { onFieldChange(e, 'engine_rest_days', e.target.value) }}
            placeholder='Enter Engine REST Period'
            InputLabelProps={{ shrink: true }}
            InputProps={{ endAdornment: <span style={{ marginLeft: '10px' }}>Day(s)</span>}}
            style={{ marginBottom: '20px' }}
            error={error?.engine_rest_days ||false}
            onFocus={()=>setError({...error,engine_rest_days:''})}
            helperText={error?.engine_rest_days ||''}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            required
            name='APU REST Period'
            label='APU REST Period'
            fullWidth
            value={restData.apu_rest_days || restData.apu_rest_days== 0? restData.apu_rest_days:''}
            disabled={type === 'view'}
            variant='outlined'
            onChange={(e) => { onFieldChange(e, 'apu_rest_days', e.target.value) }}
            placeholder='Enter APU REST Period'
            InputLabelProps={{ shrink: true }}
            InputProps={{ endAdornment: <span style={{ marginLeft: '10px' }}>Day(s)</span>}}
            error={error?.apu_rest_days ||false}
            onFocus={()=>setError({...error,apu_rest_days:''})}
            helperText={error?.apu_rest_days ||''}
            style={{ marginBottom: '20px' }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            required
            name='LG REST Period'
            label='LG REST Period'
            fullWidth
            value={restData.landing_gear_rest_days || restData.landing_gear_rest_days== 0? restData.landing_gear_rest_days:''}
            disabled={type === 'view'}
            variant='outlined'
            onChange={(e) => { onFieldChange(e, 'landing_gear_rest_days', e.target.value) }}
            placeholder='Enter LG REST Period'
            InputLabelProps={{ shrink: true }}
            InputProps={{ endAdornment: <span style={{ marginLeft: '10px' }}>Day(s)</span>}}
            style={{ marginBottom: '20px' }}
            error={error?.landing_gear_rest_days ||false}
            onFocus={()=>setError({...error,landing_gear_rest_days:''})}
            helperText={error?.landing_gear_rest_days ||''}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ padding: '20px' }}>
        {type == 'view' ? null :
          <Grid item xs={12} style={{ position: 'absolute', bottom: '20px', textAlign: 'right' }}>
            <Button variant='contained' size='small' color='primary' onClick={() => editConigData()} >Save</Button>
            <Button variant='outlined' size='small' color='primary' onClick={() => {setError({}); getConfigData(); setType('view') }} style={{ marginLeft: '10px' }} >Cancel</Button>
          </Grid>}
      </Grid>
    </Paper>
  )
}
